import { DeadlineTypeEnum } from '@zaoblako/shared/common/enums/deadline.type.enum';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';

/** Localized human-readable display names for {@link DeadlineTypeEnum} enumeration values */
export const DeadlineTypeEnumI18n: Record<I18nLocalesEnum, Record<DeadlineTypeEnum, string>> = {
  [I18nLocalesEnum.RU_RU]: {
    [DeadlineTypeEnum.ABSOLUTE]: 'Абсолютный',
    [DeadlineTypeEnum.RELATIVE]: 'Относительный',
  },
  [I18nLocalesEnum.EN_US]: {
    [DeadlineTypeEnum.ABSOLUTE]: 'Absolute',
    [DeadlineTypeEnum.RELATIVE]: 'Relative',
  },
};
